// @ts-nocheck
const ENTRY_MODAL_KEYS = {
  completed: 'entry_modal_completed',
  dismissedAt: 'entry_modal_dismissed_at',
  pendingCouponCode: 'entry_modal_pending_coupon_code',
};

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function isValidBirthdate(value) {
  if (!value) return false;
  const date = new Date(value + 'T00:00:00');
  if (Number.isNaN(date.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return date <= today;
}

function hasDiscountApplied(cart) {
  const hasCartLevelDiscount = Array.isArray(cart?.cart_level_discount_applications)
    && cart.cart_level_discount_applications.length > 0;

  const hasItemLevelDiscount = Array.isArray(cart?.items)
    && cart.items.some((item) => Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0);

  return hasCartLevelDiscount || hasItemLevelDiscount;
}

async function fetchCart() {
  const response = await fetch('/cart.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error('Não foi possível consultar o carrinho.');
  }

  return response.json();
}

async function applyDiscountCode(code) {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ discount: code }),
  });

  if (!response.ok) {
    throw new Error('Não foi possível aplicar o cupom.');
  }

  const cart = await response.json();
  return {
    cart,
    applied: hasDiscountApplied(cart),
  };
}

function shouldShowEntryModal(dialog) {
  const isLoggedIn = dialog?.dataset.customerLoggedIn === 'true';
  const ordersCount = Number(dialog?.dataset.customerOrdersCount || 0);

  if (isLoggedIn && ordersCount > 0) return false;
  if (localStorage.getItem(ENTRY_MODAL_KEYS.completed) === 'true') return false;

  var dismissedAt = localStorage.getItem(ENTRY_MODAL_KEYS.dismissedAt);
  if (dismissedAt && (Date.now() - Number(dismissedAt)) < ONE_DAY_MS) return false;

  return true;
}

const initEntryModal = (root = document) => {
  const dialog = root.querySelector('[data-entry-modal]');
  if (!dialog || dialog.dataset.entryInit === 'true') return;
  dialog.dataset.entryInit = 'true';
  const statusEl = dialog.querySelector('[data-entry-status]');
  const couponCode = ((dialog.dataset.entryCouponCode || '').trim());
  const confirmationDialog = root.querySelector('[data-entry-confirmation-modal]') || document.querySelector('[data-entry-confirmation-modal]');
  const legacyConfirmationDialog = root.querySelector('[data-entry-confirmation-modal-legacy]') || document.querySelector('[data-entry-confirmation-modal-legacy]');
  const confirmationSubtitleEl = confirmationDialog ? confirmationDialog.querySelector('.entry-confirmation-modal__subtitle') : null;
  const confirmationDescriptionEl = confirmationDialog ? confirmationDialog.querySelector('.entry-confirmation-modal__description') : null;
  const confirmationTitleEl = confirmationDialog ? confirmationDialog.querySelector('.entry-confirmation-modal__content h4') : null;
  const confirmationCouponCodeEl = confirmationDialog ? confirmationDialog.querySelector('[data-entry-coupon-display]') : null;
  const confirmationCopyBtn = confirmationDialog ? confirmationDialog.querySelector('[data-entry-copy-coupon]') : null;

  const open = () => {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const close = () => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  const dismiss = () => {
    localStorage.setItem(ENTRY_MODAL_KEYS.dismissedAt, String(Date.now()));
    close();
  };

  const openConfirmation = () => {
    if (!confirmationDialog) return;
    if (typeof confirmationDialog.showModal === 'function') {
      confirmationDialog.showModal();
    } else {
      confirmationDialog.setAttribute('open', 'open');
    }
  };

  const closeConfirmation = () => {
    if (!confirmationDialog) return;
    if (typeof confirmationDialog.close === 'function') {
      confirmationDialog.close();
    } else {
      confirmationDialog.removeAttribute('open');
    }
  };

  const openLegacyConfirmation = () => {
    if (!legacyConfirmationDialog) return;
    legacyConfirmationDialog.removeAttribute('hidden');
    if (typeof legacyConfirmationDialog.showModal === 'function') {
      legacyConfirmationDialog.showModal();
    } else {
      legacyConfirmationDialog.setAttribute('open', 'open');
    }
  };

  const closeLegacyConfirmation = () => {
    if (!legacyConfirmationDialog) return;
    if (typeof legacyConfirmationDialog.close === 'function') {
      legacyConfirmationDialog.close();
    } else {
      legacyConfirmationDialog.removeAttribute('open');
    }
  };

  const showConfirmation = (options = {}) => {
    if (confirmationTitleEl && options.title) {
      confirmationTitleEl.textContent = options.title;
    }

    if (confirmationSubtitleEl && options.subtitle) {
      confirmationSubtitleEl.textContent = options.subtitle;
    }

    if (confirmationDescriptionEl && options.description) {
      confirmationDescriptionEl.textContent = options.description;
    }

    if (confirmationCouponCodeEl) {
      confirmationCouponCodeEl.textContent = (options.couponCode || couponCode || '-').toUpperCase();
    }

    close();
    openConfirmation();
  };

  const showStatus = (message, type) => {
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.textContent = message;
    statusEl.className = `entry-modal__status entry-modal__status--${type}`;
  };

  const clearStatus = () => {
    if (!statusEl) return;
    statusEl.hidden = true;
    statusEl.textContent = '';
    statusEl.className = 'entry-modal__status';
  };

  const setSubmitting = (isSubmitting) => {
    const submitBtn = dialog.querySelector('.btn-submit');
    if (!submitBtn) return;

    submitBtn.disabled = isSubmitting;
    submitBtn.textContent = isSubmitting ? 'Aplicando...' : 'Quero meu desconto';
  };

  const setCompletedState = (buttonLabel) => {
    dialog.querySelectorAll('input, select').forEach((field) => {
      field.disabled = true;
    });

    const submitBtn = dialog.querySelector('.btn-submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = buttonLabel || 'Cadastro concluído';
    }
  };

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dismiss();
  });

  dialog.querySelectorAll('[data-entry-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      dismiss();
    });
  });

  if (confirmationDialog && confirmationDialog.dataset.entryConfirmationInit !== 'true') {
    confirmationDialog.dataset.entryConfirmationInit = 'true';
    confirmationDialog.addEventListener('click', (event) => {
      if (event.target === confirmationDialog) {
        closeConfirmation();
      }
    });

    confirmationDialog.querySelectorAll('[data-entry-confirmation-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeConfirmation();
      });
    });

    if (confirmationCopyBtn) {
      confirmationCopyBtn.addEventListener('click', async () => {
        const code = ((confirmationCouponCodeEl?.textContent || '').trim());
        if (!code || code === '-') return;

        const previousLabel = confirmationCopyBtn.textContent;

        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const tempInput = document.createElement('textarea');
            tempInput.value = code;
            tempInput.style.position = 'fixed';
            tempInput.style.opacity = '0';
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
          }

          confirmationCopyBtn.textContent = 'Copiado!';
          confirmationCopyBtn.disabled = true;
          setTimeout(() => {
            confirmationCopyBtn.textContent = 'Copiar';
            confirmationCopyBtn.disabled = false;
          }, 1500);
        } catch (error) {
          confirmationCopyBtn.textContent = previousLabel;
        }
      });
    }
  }

  if (legacyConfirmationDialog && legacyConfirmationDialog.dataset.entryConfirmationInit !== 'true') {
    legacyConfirmationDialog.dataset.entryConfirmationInit = 'true';
    legacyConfirmationDialog.addEventListener('click', (event) => {
      if (event.target === legacyConfirmationDialog) {
        closeLegacyConfirmation();
      }
    });

    legacyConfirmationDialog.querySelectorAll('[data-entry-confirmation-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeLegacyConfirmation();
      });
    });
  }

  // Submit do formulário → Google Sheets via App Proxy
  const submitBtn = dialog.querySelector('.btn-submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', async (event) => {
      event.preventDefault();
      clearStatus();
      let keepCompletedState = false;

      const nome = ((dialog.querySelector('input[name="entry_name"]') || {}).value || '').trim();
      const email = ((dialog.querySelector('input[name="entry_email"]') || {}).value || '').trim();
      const data_nascimento = ((dialog.querySelector('input[name="entry_birthdate"]') || {}).value || '').trim();
      const estado = ((dialog.querySelector('select[name="entry_state"]') || {}).value || '').trim();

      if (!nome || !email || !data_nascimento || !estado) {
        showStatus('Por favor, preencha todos os campos obrigatórios.', 'error');
        return;
      }

      if (nome.length < 3) {
        showStatus('Informe seu nome completo.', 'error');
        return;
      }

      if (!isValidEmail(email)) {
        showStatus('Informe um e-mail válido.', 'error');
        return;
      }

      if (!isValidBirthdate(data_nascimento)) {
        showStatus('Informe uma data de nascimento válida.', 'error');
        return;
      }

      // Coleta categorias selecionadas (texto do label)
      var checkboxes = dialog.querySelectorAll('input[name="entry_categories[]"]:checked');
      var categorias = [];
      checkboxes.forEach(function(cb) {
        var label = dialog.querySelector('label[for="' + cb.id + '"]');
        categorias.push(label ? label.textContent.trim() : cb.value);
      });

      if (categorias.length === 0) {
        showStatus('Selecione pelo menos uma categoria de interesse.', 'error');
        return;
      }

      var params = new URLSearchParams(window.location.search);

      var data = {
        nome: nome,
        email: email,
        telefone: '',
        mensagem: '',
        data_nascimento: data_nascimento.split('-').reverse().join('/'),
        estado: estado,
        categorias: categorias.join(', '),
        origem: 'entry-modal',
        page_url: window.location.href,
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_term: params.get('utm_term') || '',
        utm_content: params.get('utm_content') || ''
      };

      try {
        setSubmitting(true);

        const response = await fetch('/apps/hub-proxy/api/form-submit', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error('Não foi possível finalizar seu cadastro.');
        }

        localStorage.setItem(ENTRY_MODAL_KEYS.completed, 'true');
        localStorage.removeItem(ENTRY_MODAL_KEYS.dismissedAt);

        if (!couponCode) {
          keepCompletedState = true;
          setCompletedState('Cadastro concluído');
          showConfirmation({
            title: 'Cadastro realizado!',
            description: 'Seu cupom de 5% OFF será aplicado no cariinho na finalização da compra.',
            couponCode: '-',
          });
          return;
        }

        let cart;
        try {
          cart = await fetchCart();
        } catch (cartError) {
          localStorage.setItem(ENTRY_MODAL_KEYS.pendingCouponCode, couponCode);
          keepCompletedState = true;
          setCompletedState('Cupom vinculado');
          showConfirmation({
            title: 'Cadastro realizado!',
            description: 'Seu cupom de 5% OFF está pronto. Use na finalização da compra.',
            couponCode,
          });
          return;
        }

        if (!cart.item_count) {
          localStorage.setItem(ENTRY_MODAL_KEYS.pendingCouponCode, couponCode);
          keepCompletedState = true;
          setCompletedState('Cupom salvo');
          showConfirmation({
            title: 'Cadastro realizado!',
            description: 'Seu cupom de 5% OFF está pronto. Use na finalização da compra.',
            couponCode,
          });
          return;
        }

        if (hasDiscountApplied(cart)) {
          localStorage.setItem(ENTRY_MODAL_KEYS.pendingCouponCode, couponCode);
          keepCompletedState = true;
          setCompletedState('Cupom salvo');
          showConfirmation({
            title: 'Cadastro realizado!',
            description: 'Seu cupom de 5% OFF está pronto. Use na finalização da compra.',
            couponCode,
          });
          return;
        }

        const { applied } = await applyDiscountCode(couponCode);

        if (!applied) {
          localStorage.setItem(ENTRY_MODAL_KEYS.pendingCouponCode, couponCode);
          keepCompletedState = true;
          setCompletedState('Cupom salvo');
          showConfirmation({
            title: 'Cadastro realizado!',
            description: 'Seu cupom de 5% OFF está pronto. Use na finalização da compra.',
            couponCode,
          });
          return;
        }

        localStorage.removeItem(ENTRY_MODAL_KEYS.pendingCouponCode);
        window.dispatchEvent(new CustomEvent('entry-modal:coupon-applied', { detail: { code: couponCode } }));
        keepCompletedState = true;
        setCompletedState('Cupom aplicado');
        showConfirmation({
          title: 'Cadastro realizado!',
          description: 'Seu cupom de 5% OFF está pronto. Use na finalização da compra.',
          couponCode,
        });
      } catch (error) {
        showStatus(error.message || 'Não foi possível concluir o cadastro. Tente novamente.', 'error');
      } finally {
        if (!keepCompletedState) {
          setSubmitting(false);
        }
      }
    });
  }

  // Auto-open após 5 segundos se permitido pelas regras
  if (shouldShowEntryModal(dialog)) {
    setTimeout(() => open(), 5000);
  }

  window.openEntryModal = open;
  window.closeEntryModal = close;
};

document.addEventListener('DOMContentLoaded', () => initEntryModal());
document.addEventListener('shopify:section:load', (event) => initEntryModal(event.target));
